import { ITripBookingPassenger, ITripRoomGuest } from "@cruisen/contract"
import styles from "./styles.module.scss"
import CheckmarkOutline from "~icons/eva/checkmark-outline"
import { QuoteCard } from "../QuoteCard"

export const QuoteRoomCard = ({
  tripRoomName,
  roomGuests,
  onGuestClick,
  cruiseDetails,
  arePassengersLoaded,
}: {
  tripRoomName: string
  roomGuests: (ITripRoomGuest & { passengerData: ITripBookingPassenger })[]
  onGuestClick: (guestId: string) => void
  cruiseDetails: {
    deckName: string
    cabinNo: string
    cabinGradeName: string
  }
  arePassengersLoaded: boolean
}) => {
  return (
    <QuoteCard title={tripRoomName}>
      <div className={styles.roomInfo}>
        {cruiseDetails.deckName && cruiseDetails.cabinNo ? (
          <p className={styles.roomNumber}>
            {cruiseDetails.deckName} · Cabin {cruiseDetails.cabinNo}
          </p>
        ) : null}
        <p className={styles.roomType}>{cruiseDetails.cabinGradeName} cabin</p>
      </div>
      <div className={styles.divider} />
      <div className={styles.sailorInfo}>
        <p className={styles.sailorTitle}>Sailor info</p>
        {roomGuests.map((guest) => {
          const isDataFilled =
            guest.passengerData !== undefined &&
            Object.entries(guest.passengerData).every(([key, val]) => {
              if (
                key === "passportNumber" ||
                key === "passportExpireDate" ||
                key === "passportIssueDate" ||
                key === "passportIssuingCountry" ||
                key === "loyaltyNumber" ||
                key === "passportTokenId" ||
                (key === "county" && guest.passengerData.country !== "US")
              )
                return true
              return val !== ""
            })

          const guestFirstName = guest?.passengerData?.firstName || guest.firstName
          const guestLastName = guest?.passengerData?.lastName || guest.lastName

          return (
            <div key={guest.id} className={styles.sailorCard}>
              <p className={styles.sailorName}>
                {guestFirstName} {guestLastName}
              </p>
              <div className={styles.endRow}>
                {isDataFilled ? (
                  <div className={styles.checkmarkContainer}>
                    <CheckmarkOutline className={styles.checkmark} />
                  </div>
                ) : null}
                <button
                  className={styles.editButton}
                  disabled={!arePassengersLoaded}
                  onClick={() => onGuestClick(guest.userId || guest.id)}
                >
                  {!arePassengersLoaded ? "Loading..." : isDataFilled ? "Edit" : "Add"}
                </button>
              </div>
            </div>
          )
        })}
      </div>
    </QuoteCard>
  )
}
